module.exports = __webpack_public_path__ + "img/utenkluss.4963a688.gif";